export default __webpack_public_path__ + "static/media/story7.501c1c5a.jpg";